'use client';

import React, { createContext, useMemo, useEffect } from 'react';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { CSRBuddyTypes } from '@/utils/csrbuddy/types';

export type CSRBuddyContextProps = {
  isCSRBEnv?: boolean;
  featureFlags: FeatureFlags
};
export type CSRBuddyContextProviderProps = {
  children: React.ReactNode;
  context?: CSRBuddyContextProps;
};
type FeatureFlags = Readonly<{
  [key: string]: unknown;
}>

const initialCSRBuddyContext: CSRBuddyContextProps = {
  isCSRBEnv: false,
  featureFlags: {}
};

export const CSRBuddyContext = createContext<CSRBuddyContextProps>(initialCSRBuddyContext);

export const CSRBuddyContextProvider: React.FC<CSRBuddyContextProviderProps> = ({ children }) => {
  const { storedValue: isCSRBEnv, setValue: setIsCSRBEnv } = useLocalStorage<boolean>(
    'isCsrbStyles',
    false,
  );
  const { storedValue: featureFlags, setValue: setFeatureFlags } = useLocalStorage<FeatureFlags>(
    'csrbFeatureFlags',
    initialCSRBuddyContext.featureFlags
  );
  const handleIframeLoad = () => {
      // Create link
      console.log('postmate connection is successful')
       const link = document.createElement('link');
       link.rel = 'stylesheet';
       link.type = 'text/css';
       link.href = CSRBuddyTypes.EnterpriseStyleSheet;
       console.log({link: link.href})
       // Append link to the head of the document
       try{
         const iframeReference = document.getElementById('enactment-iframe') as HTMLIFrameElement;
         iframeReference.contentWindow?.document?.head?.appendChild(link)
         console.log('styling changes are completed')
       }
       catch(error) {
         console.log('error', error)
       }
  }

  const eventHandler = (event: unknown) => {
    const { detail } = event as CustomEvent<{ featureFlags: unknown } | null>;
    const featureFlags = detail?.featureFlags;
    if (featureFlags && typeof featureFlags === 'object') {
      setFeatureFlags(featureFlags as FeatureFlags);
    }
    setIsCSRBEnv(true);
  };

  useEffect(() => {
    if(isCSRBEnv) {
      handleIframeLoad();
    }
  }, [isCSRBEnv])

  useEffect(() => {
    window.addEventListener('csrbuddy2', eventHandler);
    return () => {
      window.removeEventListener('csrbuddy2', eventHandler);
    };
  }, []);

  const value = useMemo(() => ({ isCSRBEnv, featureFlags }), [isCSRBEnv, featureFlags]);

  return <CSRBuddyContext.Provider value={value}>{children}</CSRBuddyContext.Provider>;
};
